The date & time the event was created.

This is commonly linked to the creation of an object that can be retrieved from the SEEK API.

The data source for this field differs by event type and scheme.
This field has weak ordering guarantees, so it should not be used as a pagination argument.
